// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageCollapsedHeaderSenderAdditionalInfo-moduleEmailProfileMessageCollapsedHeaderSenderAdditionalInfo__b9JOW";
var _2 = "EmailProfileMessageCollapsedHeaderSenderAdditionalInfo-moduletag__EoIYl Tag-moduleTag__FLr9H";
var _3 = "EmailProfileMessageCollapsedHeaderSenderAdditionalInfo-moduletags__c8d1W";
var _4 = "EmailProfileMessageCollapsedHeaderSenderAdditionalInfo-moduletext__KqLFu";
export { _1 as "EmailProfileMessageCollapsedHeaderSenderAdditionalInfo", _2 as "tag", _3 as "tags", _4 as "text" }
